import { AUDIO_PRESENTER } from '@shoflo/polymer/constants/SourceItems';
import { combineMuteStatusWithAudioSourceInProgram } from '@shoflo/polymer/utils/broadcastSourceHelper/broadcastSourceHelper';
import { logProgramChange } from '@shoflo/studio-redux/utils/sendToDatadogWithIds';

import {
  BROADCAST_SET_ATTENDEE_MUTE_STATUS,
  BROADCAST_SET_MULTIPLE_DESIRED_ATTENDEE_MUTE_STATUSES
} from 'actions/Types';
import { isEmpty } from 'underscore';
import setProgram from 'actions/Broadcast/program/setProgram';
import {
  getProgramLayers,
  addAudioPresentersToProgramLayer,
  attachAudioPresenterSources
} from 'utils/broadcastSourceHelper';

/**
 * Adds audio presenter layer to program when mic status changes
 * @param {{}} store
 */
function addAudioPresenterLayerToProgram(store) {
  return next => {
    return async action => {
      const { dispatch, getState } = store;
      if (action.type === BROADCAST_SET_ATTENDEE_MUTE_STATUS) {
        const state = getState();
        const {
          program,
          broadcastSources: { sources },
          attendeeMuteStatus
        } = state;

        const isMuted = action.payload.isMuted;
        const attendeeId = action.payload.attendeeId;
        const extendedAttendeeMuteStatus =
          combineMuteStatusWithAudioSourceInProgram(
            sources,
            program,
            attendeeMuteStatus
          );

        const withAudioPresenterSources = attachAudioPresenterSources(sources, {
          ...extendedAttendeeMuteStatus,
          [attendeeId]: isMuted
        });

        const programLayersWithoutAudioSources = program?.layers?.filter(
          layer => layer.source.type !== AUDIO_PRESENTER
        );

        const withAudioPresenterLayer = addAudioPresentersToProgramLayer(
          programLayersWithoutAudioSources,
          withAudioPresenterSources
        );

        const updatedProgram = {
          ...program,
          layers: withAudioPresenterLayer
        };

        /** Check if attendee already has audioPresenter */
        const attendeeAudioPresenterExists = !!getProgramLayers(program).find(
          ({ source }) =>
            source.type === AUDIO_PRESENTER && source._id === attendeeId
        );

        let shouldUpdateProgram = true;

        // When attendee Audio Source exists in program and the attendee' mute state is `not muted`,
        // we dont need to update program since the attendee' mute source is in program already
        if (attendeeAudioPresenterExists && !isMuted) {
          shouldUpdateProgram = false;
        }

        // When the attendee has just been muted is: isMuted is true and the audio source is not in program dont do anything!
        if (!attendeeAudioPresenterExists && isMuted) {
          shouldUpdateProgram = false;
        }

        if (shouldUpdateProgram) {
          dispatch(setProgram(updatedProgram, false, { emitSocket: false }));
          logProgramChange(
            getState,
            'addAudioPresenterLayerToProgram middleware'
          );
        }

        const updatedAttendeeMuteStatus = {};
        Object.keys(extendedAttendeeMuteStatus).forEach(attendeeId => {
          if (
            attendeeMuteStatus[attendeeId] !==
            extendedAttendeeMuteStatus[attendeeId]
          ) {
            updatedAttendeeMuteStatus[attendeeId] =
              extendedAttendeeMuteStatus[attendeeId];
          }
        });
        if (!isEmpty(updatedAttendeeMuteStatus)) {
          dispatch({
            type: BROADCAST_SET_MULTIPLE_DESIRED_ATTENDEE_MUTE_STATUSES,
            payload: updatedAttendeeMuteStatus
          });
        }
      }
      return next(action);
    };
  };
}

export default addAudioPresenterLayerToProgram;
